export default __webpack_public_path__ + "static/media/gallery-img-9.83e2f21d.jpg";